/**
 * @fileoverview gRPC-Web generated client stub for fitness.service.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: fitness-service/v1/exercise.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.fitness = {};
proto.fitness.service = {};
proto.fitness.service.v1 = require('./exercise_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.fitness.service.v1.ExerciseServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.fitness.service.v1.ExerciseServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.CreateExerciseRequest,
 *   !proto.fitness.service.v1.CreateExerciseResponse>}
 */
const methodDescriptor_ExerciseService_CreateExercise = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.ExerciseService/CreateExercise',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.CreateExerciseRequest,
  proto.fitness.service.v1.CreateExerciseResponse,
  /**
   * @param {!proto.fitness.service.v1.CreateExerciseRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.CreateExerciseResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.CreateExerciseRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.CreateExerciseResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.CreateExerciseResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.ExerciseServiceClient.prototype.createExercise =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.ExerciseService/CreateExercise',
      request,
      metadata || {},
      methodDescriptor_ExerciseService_CreateExercise,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.CreateExerciseRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.CreateExerciseResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.ExerciseServicePromiseClient.prototype.createExercise =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.ExerciseService/CreateExercise',
      request,
      metadata || {},
      methodDescriptor_ExerciseService_CreateExercise);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.GetExercisesRequest,
 *   !proto.fitness.service.v1.GetExercisesResponse>}
 */
const methodDescriptor_ExerciseService_GetExercises = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.ExerciseService/GetExercises',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.GetExercisesRequest,
  proto.fitness.service.v1.GetExercisesResponse,
  /**
   * @param {!proto.fitness.service.v1.GetExercisesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.GetExercisesResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.GetExercisesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.GetExercisesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.GetExercisesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.ExerciseServiceClient.prototype.getExercises =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.ExerciseService/GetExercises',
      request,
      metadata || {},
      methodDescriptor_ExerciseService_GetExercises,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.GetExercisesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.GetExercisesResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.ExerciseServicePromiseClient.prototype.getExercises =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.ExerciseService/GetExercises',
      request,
      metadata || {},
      methodDescriptor_ExerciseService_GetExercises);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.GetExerciseRequest,
 *   !proto.fitness.service.v1.GetExerciseResponse>}
 */
const methodDescriptor_ExerciseService_GetExercise = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.ExerciseService/GetExercise',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.GetExerciseRequest,
  proto.fitness.service.v1.GetExerciseResponse,
  /**
   * @param {!proto.fitness.service.v1.GetExerciseRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.GetExerciseResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.GetExerciseRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.GetExerciseResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.GetExerciseResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.ExerciseServiceClient.prototype.getExercise =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.ExerciseService/GetExercise',
      request,
      metadata || {},
      methodDescriptor_ExerciseService_GetExercise,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.GetExerciseRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.GetExerciseResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.ExerciseServicePromiseClient.prototype.getExercise =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.ExerciseService/GetExercise',
      request,
      metadata || {},
      methodDescriptor_ExerciseService_GetExercise);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.UpdateExerciseRequest,
 *   !proto.fitness.service.v1.UpdateExerciseResponse>}
 */
const methodDescriptor_ExerciseService_UpdateExercise = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.ExerciseService/UpdateExercise',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.UpdateExerciseRequest,
  proto.fitness.service.v1.UpdateExerciseResponse,
  /**
   * @param {!proto.fitness.service.v1.UpdateExerciseRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.UpdateExerciseResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.UpdateExerciseRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.UpdateExerciseResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.UpdateExerciseResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.ExerciseServiceClient.prototype.updateExercise =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.ExerciseService/UpdateExercise',
      request,
      metadata || {},
      methodDescriptor_ExerciseService_UpdateExercise,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.UpdateExerciseRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.UpdateExerciseResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.ExerciseServicePromiseClient.prototype.updateExercise =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.ExerciseService/UpdateExercise',
      request,
      metadata || {},
      methodDescriptor_ExerciseService_UpdateExercise);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fitness.service.v1.DeleteExerciseRequest,
 *   !proto.fitness.service.v1.DeleteExerciseResponse>}
 */
const methodDescriptor_ExerciseService_DeleteExercise = new grpc.web.MethodDescriptor(
  '/fitness.service.v1.ExerciseService/DeleteExercise',
  grpc.web.MethodType.UNARY,
  proto.fitness.service.v1.DeleteExerciseRequest,
  proto.fitness.service.v1.DeleteExerciseResponse,
  /**
   * @param {!proto.fitness.service.v1.DeleteExerciseRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.fitness.service.v1.DeleteExerciseResponse.deserializeBinary
);


/**
 * @param {!proto.fitness.service.v1.DeleteExerciseRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fitness.service.v1.DeleteExerciseResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fitness.service.v1.DeleteExerciseResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.fitness.service.v1.ExerciseServiceClient.prototype.deleteExercise =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/fitness.service.v1.ExerciseService/DeleteExercise',
      request,
      metadata || {},
      methodDescriptor_ExerciseService_DeleteExercise,
      callback);
};


/**
 * @param {!proto.fitness.service.v1.DeleteExerciseRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fitness.service.v1.DeleteExerciseResponse>}
 *     Promise that resolves to the response
 */
proto.fitness.service.v1.ExerciseServicePromiseClient.prototype.deleteExercise =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/fitness.service.v1.ExerciseService/DeleteExercise',
      request,
      metadata || {},
      methodDescriptor_ExerciseService_DeleteExercise);
};


module.exports = proto.fitness.service.v1;

